import { types } from '../types'

const initialState = {
  waiting: false,
  success: false,
  error: '',
  onHoldMusics: [],
  numberIVRSettings: undefined,
  saveIVR_Pending: false,
  saveIVR_Error: null,
  saveIVR_Success: false,
  calendarFridaysState: false,
  calendarHolidaysState: false,



}

const ivrReducer = (state = initialState, { type, action, error }) => {
  switch (type) {


    case types.GET_IVR_SETTINGS_REQUEST: {
      return {
        ...state,
        getIVRPending: true,
        getIVRError: null,
        numberIVRSettings: undefined

      }
    }
    case types.GET_IVR_SETTINGS_REQUEST_SUCCESS: {

      return {
        ...state,
        getIVRPending: false,
        numberIVRSettings: action.data

      }
    }
    case types.GET_IVR_SETTINGS_REQUEST_ERROR: {
      return {
        ...state,
        getIVRPending: false,
        getIVRError: error,


      }
    }
    case types.GET_ALL_MUSIC_ON_HOLD: {
      return {
        ...state,
        getOnHoldMusicsPending: true,
        getOnHoldMusicsError: null,
        onHoldMusics: []

      }
    }
    case types.GET_ALL_MUSIC_ON_HOLD_SUCCESS: {

      return {
        ...state,
        getOnHoldMusicsPending: false,
        onHoldMusics: action.data

      }
    }
    case types.GET_ALL_MUSIC_ON_HOLD_ERROR: {
      return {
        ...state,
        getOnHoldMusicsPending: false,
        getOnHoldMusicsError: error,


      }
    }



    case types.GET_AUDIO_LINK_REQUEST: {
      return {
        ...state,
        getAudioLinkPending: true,
        getAudioLinkError: null,
        getAudioLinkSettings: null

      }
    }

    case types.GET_AUDIO_LINK_REQUEST_SUCCESS: {
      return {
        ...state,
        getAudioLinkPending: false,
        audioLink: action.data

      }
    }

    case types.GET_AUDIO_LINK_REQUEST_ERROR: {
      return {
        ...state,
        getAudioLinkPending: false,
        getAudioLinkError: error,


      }
    }


    case types.SAVE_IVR_SETTINGS_REQUEST: {
      return {
        ...state,
        saveIVR_Pending: true,
        saveIVR_Error: null,
        saveIVR_Success: false,

        saveIVR_Settings: null

      }
    }

    case types.SAVE_IVR_SETTINGS_REQUEST_SUCCESS: {
      return {
        ...state,
        saveIVR_Pending: false,
        saveIVR_Success: true,


      }
    }

    case types.SAVE_IVR_SETTINGS_REQUEST_ERROR: {
      return {
        ...state,
        saveIVR_Pending: false,
        saveIVR_Error: error,


      }
    }


    case types.GET_S3URL_REQUEST: {
      return {
        ...state,
        getS3Url_Pending: true,
        getS3Url_Error: null,
        getS3Url_Success: false,

        getS3UrlResult: null

      }
    }

    case types.GET_S3URL_SUCCESS: {
      return {
        ...state,
        getS3Url_Pending: false,
        getS3Url_Success: true,
        getS3UrlResult: action.data,
        getS3Url_Error: false,


      }
    }

    case types.GET_S3URL_ERROR: {
      return {
        ...state,
        getS3Url_Pending: false,
        getS3Url_Error: error,


      }
    }


    case types.UPLOAD_REQUEST: {
      return {
        ...state,
        uploadPending: true,
        uploadError: null,
        uploadSuccess: false,
        uploadResult: null

      }
    }

    case types.UPLOAD_SUCCESS: {
      return {
        ...state,
        uploadPending: false,
        uploadSuccess: true,
        getS3UrlResult: action.data,
        uploadError: false,


      }
    }

    case types.UPLOAD_ERROR: {
      return {
        ...state,
        uploadPending: false,
        uploadError: error,


      }
    }



    case types.S3URL_RESET_PROPS: {
      return {
        ...state,
        getS3Url_Pending: false,
        getS3Url_Error: null,
        getS3Url_Success: false,
        getS3Url_Settings: null,
        getS3UrlResult: null

      }
    }


    case types.IVR_SETTING_SET_CALENDAR_FRIDAYS_STATE: {
      return {
        ...state,
        calendarFridaysState: action

      }
    }


    case types.IVR_SETTING_SET_CALENDAR_HOLIDAY_STATE: {
      return {
        ...state,
        calendarHolidaysState: action

      }
    }

    case types.IVR_PROPS_RESET: {
      return {
        ...state,
        getIVRPending: false,
        getIVRError: null,
        getIVRSettings: null,
        getAudioLinkPending: false,
        getAudioLinkError: null,
        getAudioLinkSettings: null,
        saveIVR_Pending: false,
        saveIVR_Error: null,
        saveIVR_Success: false,
        getS3Url_Pending: false,
        getS3Url_Error: null,
        getS3Url_Success: false,
        getS3Url_Settings: null,

      }
    }

    default:
      return state
  }
}

export default ivrReducer;